import { render, staticRenderFns } from "./LoadingIcon.vue?vue&type=template&id=4bef65d3&scoped=true"
import script from "./LoadingIcon.vue?vue&type=script&lang=js"
export * from "./LoadingIcon.vue?vue&type=script&lang=js"
import style0 from "./LoadingIcon.vue?vue&type=style&index=0&id=4bef65d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bef65d3",
  null
  
)

export default component.exports